<div class="modal-wrapper text-center">
    <div class="d-flex justify-content-between">
        <button class="btn btn-primary" [disabled]="loading || loadingImage" (click)="downloadReport()">Baixar Relatório <div class="btn-spinner position-relative float-right" *ngIf="loading || loadingImage"></div></button>

        <button class="btn p-0" title="Cancelar" aria-label="Cancelar" (click)="closeModal()">
            <i class="fal fa-times font-weight-medium"></i>
        </button>
    </div>

    <div #reportContent class="report-content">
        <div class="image-wrapper">
            <img class="w-100" [src]="projectImage" alt="Report background">
            <p class="project-title">{{projectName}}</p>
        </div>
        <div class="inner-content">
            <img class="reframe-logo" src="assets/images/logo/logo-green.svg" alt="Reframe logo ">

            <p class="project-description">{{projectDescription}}</p>
            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title">TOTAL DE EMISSÕES</span>
                <span class="project-kgco2">KG CO2e</span>
                <span class="project-data-value">{{projectData?.totalEmissions | number: '1.2-2'}}</span>
            </div>

            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title">EMISSÕES COMPENSADAS</span>
                <span class="project-kgco2">KG CO2e</span>
                <span class="project-data-value">{{projectData?.totalOffsetEmissions | number: '1.2-2'}}</span>
            </div>

            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title">RESULTADO</span>

                <div class="project-data-score">
                    <span class="score score-a" [ngClass]="{'score-selected': projectData?.score === 'A'}">A</span>
                    <span class="score score-b" [ngClass]="{'score-selected': projectData?.score === 'B'}">B</span>
                    <span class="score score-c" [ngClass]="{'score-selected': projectData?.score === 'C'}">C</span>
                    <span class="score score-d" [ngClass]="{'score-selected': projectData?.score === 'D'}">D</span>
                    <span class="score score-e" [ngClass]="{'score-selected': projectData?.score === 'E'}">E</span>
                </div>
            </div>

            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title">MODALIDADE DE COMPENSAÇÃO</span>
            </div>

            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title custom-margin-right">{{projectData?.offsetModalities[0].percentage | number: '1.2-2'}}%</span>
                <span class="project-kgco2">RESTAURAÇÃO</span>
                <span class="project-data-title margin-left-em">{{projectData?.offsetModalities[1].percentage | number: '1.2-2'}}%</span>
                <span class="project-kgco2">ENERGIA FOTOVOLTAICA</span>
            </div>

            <div class="divider"></div>

            <div class="project-data-row">
                <span class="project-data-title">&nbsp;</span>
            </div>





            <div class="project-data-row green-bg">
                <span class="project-data-title">NÍVEL DE ESG</span>
                <span class="project-kgco2">TOTAL</span>
                <span class="project-data-title margin-left-em-2">{{projectData.esgScoreResult.score | number: '1.0-2'}}%</span>
                <span class="project-data-value advanced">{{projectData.esgScoreResult.level | esgStatus}}</span>
            </div>
            <div class="divider"></div>

            <div class="project-data-row-esg">
                <div class="esg-data">
                    <p class="esg-title">ENVIRONMENTAL</p>
                       <div class="text-left d-inline-block w-100">
                           <span class="esg-percentage">{{projectData?.esgScoreResult.pillars[2].score | number: '1.0-0'}}%</span>
                           <span class="esg-level">{{projectData?.esgScoreResult.pillars[2].level | esgStatus}}</span>
                       </div>
                </div>
                <div class="esg-data">
                    <p class="esg-title">SOCIAL</p>
                       <div class="text-left d-inline-block w-100">
                           <span class="esg-percentage">{{projectData?.esgScoreResult.pillars[0].score | number: '1.0-0'}}%</span>
                           <span class="esg-level">{{projectData?.esgScoreResult.pillars[0].level | esgStatus}}</span>
                       </div>
                </div>
                <div class="esg-data">
                    <p class="esg-title">GOVERNANCE</p>
                    <div class="text-left d-inline-block w-100">
                        <span class="esg-percentage">{{projectData?.esgScoreResult.pillars[1].score | number: '1.0-0'}}%</span>
                        <span class="esg-level">{{projectData?.esgScoreResult.pillars[1].level | esgStatus}}</span>
                    </div>
                </div>

            </div>
            <div class="divider"></div>
        </div>
        <div class="footer-content">
            <img class="footer-logo" src="assets/images/apro/apro-logo.png" alt="Apro logo">
            <span class="footer-text">© {{currentYear}} Copyright APRO</span>
        </div>
    </div>




</div>